import React from 'react';

import { parseWorkflowViewState } from '@aline/common';
import { NameDialog, NameDialogVariant } from 'src/components';

import { useCreateDraftViewAndOpenBuilder } from './create-draft-view-and-open-builder';
import {
  createDefaultWorkflowListChartConfig,
  WORKFLOW_LIST_CHART_ID,
} from '../workflow/workflow-list/workflow-list-charts';

interface CreateInsightChartDialogProps {
  onClose: () => void;
  open: boolean;
}

export function CreateInsightChartDialog({
  onClose,
  open,
}: CreateInsightChartDialogProps): JSX.Element {
  const { createDraftViewAndOpenBuilder } = useCreateDraftViewAndOpenBuilder();

  const handleCreate = async (name: string) => {
    const trimmedName = name.trim();
    if (!trimmedName) return;

    const viewId = await createDraftViewAndOpenBuilder({
      chartId: WORKFLOW_LIST_CHART_ID,
      failureMessage: 'Failed to create chart view.',
      name: trimmedName,
      state: parseWorkflowViewState({
        chartsIntegration: {
          activeChartId: WORKFLOW_LIST_CHART_ID,
          charts: {
            [WORKFLOW_LIST_CHART_ID]: createDefaultWorkflowListChartConfig({
              title: trimmedName,
            }),
          },
        },
        workflowFilter: { variant: 'Contract' },
      }),
    });
    if (viewId) onClose();
  };

  return (
    <NameDialog
      handleClose={onClose}
      open={open}
      placeholder="Add a name for your chart view..."
      variant={NameDialogVariant.CreateChartView}
      onFormikSubmit={handleCreate}
    />
  );
}
